import { render } from "./SVGColorItem.vue?vue&type=template&id=1143c060"
import script from "./SVGColorItem.vue?vue&type=script&lang=js"
export * from "./SVGColorItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__